/* pantallas-alumno (B): EL RECUADRO DE LO QUE FALTA (piezas nuevas de la parte 1; CE15, CE19).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Naranja suave en Settings del Centro (fondo #1A120C, borde #3A2414, radio 14, relleno 14): triangulo
   naranja de 18 y el texto de 14 px #E8D5C6; debajo, el boton secundario a lo ancho (44; 48 en el
   celular) con el icono de chispa. El mismo para flashcards y para preguntas.

   Trabajando: apagado, giro y el texto de avance que pasa quien lo usa ("Generating {current}/{total}...",
   `study:center.missing_flashcards.generating_btn`). El boton va a lo ancho: cambiar el texto no le
   cambia el ancho. `sinRed` + `alTocarApagado`: la app sin red (firma 1 de la parte 1: el boton va
   apagado, al 38 % de la seccion 4.1 del encargo, y al tocarlo sale "You need a connection").
   `apagadoSuave` es el mismo apagado por otro motivo, al 45 %. */
import React from 'react';
import { AlertTriangle, Loader2, Sparkles } from 'lucide-react';
import { TONO_NARANJA_SUAVE, OPACIDAD_APAGADO, OPACIDAD_SIN_RED } from './estilos';
import { APRETADO } from './botones';

export default function RecuadroDeLoQueFalta({
  texto, textoBoton, onGenerar, trabajando = false, textoTrabajando, apagado = false, apagadoSuave = false, sinRed = false,
  alTocarApagado, testid,
}) {
  const suave = apagadoSuave || sinRed;
  const alTocar = () => {
    if (suave) { if (alTocarApagado) alTocarApagado(); return; }
    if (onGenerar) onGenerar();
  };
  return (
    <div data-testid={testid} className="rounded-[14px] border p-3.5"
      style={{ backgroundColor: TONO_NARANJA_SUAVE.fondo, borderColor: TONO_NARANJA_SUAVE.borde }}>
      <div className="flex items-start gap-2.5">
        <AlertTriangle data-parte="triangulo" className="w-[18px] h-[18px] shrink-0 mt-px text-[#F27A2E]" aria-hidden="true" />
        <p data-parte="texto" className="min-w-0 text-[14px] leading-5 text-[#E8D5C6] break-words">{texto}</p>
      </div>
      <button
        type="button"
        onClick={alTocar}
        disabled={apagado || trabajando}
        aria-busy={trabajando || undefined}
        aria-disabled={suave || undefined}
        style={suave ? { opacity: sinRed ? OPACIDAD_SIN_RED : OPACIDAD_APAGADO } : undefined}
        data-testid={testid ? `${testid}-boton` : undefined}
        className={`mt-3 w-full h-12 md:h-11 px-4 rounded-xl bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3] text-[14px] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-45 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}
      >
        {trabajando
          ? <Loader2 className="w-4 h-4 shrink-0 animate-spin" aria-hidden="true" />
          : <Sparkles className="w-4 h-4 shrink-0 text-[#F7A06A]" aria-hidden="true" />}
        <span className="truncate">{trabajando && textoTrabajando ? textoTrabajando : textoBoton}</span>
      </button>
    </div>
  );
}
